export default {
  CustomReportDelete: 'CustomReportDelete',
  CustomReportEdit: 'CustomReportEdit',
  CustomReportParam: 'CustomReportParam',
  CustomReportTestQueryParam: 'CustomReportTestQueryParam',
  ExportCustomReportInsertQuery: 'ExportCustomReportInsertQuery',
  ValidationConfirmation: 'ValidationConfirmation',
};
